const MaritalKeys = {
  single: "single",
  married: "married",
  divorced: "divorced",
  widowed: "widowed",
};

export default MaritalKeys;
